export const routes = {
  login: "/login",
  upload: "/upload",
  thumbnail: "/thumbnail",
  landingPage: "/",
};
